// extracted by mini-css-extract-plugin
export default {"CrewAndCast_div":"CrewAndCast_CrewAndCast_div__9SQup","CrewAndCast_Image":"CrewAndCast_CrewAndCast_Image__qL2wL","heading_style":"CrewAndCast_heading_style__RROMo"};